const Footer = () => {
  return (
    <footer className='footer page-footer blue-grey'>
      <span>Copyright © 2024 by Christine Fong</span>
      <span>Developed by : Chirstine Fong | <a className='grey-text text-lighten-4' href='https://github.com/penguinff' target='_blank' rel='noreferrer noopener'>Github</a></span>
      <span>Data Source : <a className='grey-text text-lighten-4' href='https://disease.sh/' target='_blank' rel='noreferrer noopener'>https://disease.sh/</a></span>
    </footer>
  )
}

export default Footer;